import React from 'react';
import { Link } from 'react-router-dom';

import { spanish } from '../../../config/config';

const lang = spanish ? '/mex/es-mx' : '/mex/en-us';

const LinkLang = ({ to, className, children, state }) => (
  <Link to={{ pathname: `${lang}${to}`, state }} className={className}>
    {children}
  </Link>
);

export default LinkLang;
